module.exports = __webpack_public_path__ + "img/imgacceptbt.2151bf2c.png";